import { useEffect, useRef } from "react";
import {
  pushModal,
  popModal,
  isTopModal,
  getModalStack,
} from "../utils/modalStack";

export function useOutsideClick(handler, listenCapturing = true) {
  const ref = useRef();
  useEffect(() => {
    function handleClick(e) {
      if (ref.current && !ref.current.contains(e.target) && isTopModal(ref)) {
        handler();
        popModal();
      }
    }

    pushModal(ref);
    document.addEventListener("click", handleClick, listenCapturing);

    return () => {
      popModal();
      document.removeEventListener("click", handleClick);
    };
  }, [handler, listenCapturing]);

  return ref;
}
